import useFormatDateTime from "../useFormatDateTime/useFormatDateTime";
import { FormatDateParams, FormatIntlOptionsMap, AnyDate } from "./useFormatDate.types";

export const FORMAT_INTL_OPTIONS_MAP: FormatIntlOptionsMap = {
    default: {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
    },
    compact: {
        hour: "2-digit",
        minute: "2-digit",
    },
};

/**
 * Hook to format a date.
 * - `default` - 12/12/2012
 * - `compact` - Today, 18:20 | Yesterday, 18:20 | 12/12/2012, 18:20
 *
 * If you need more customization, use the hooks: `useFormatDateTime` or `useFormatRelativeTime` instead.
 */
export default function (): (date: AnyDate | undefined, params?: FormatDateParams) => string {
    const formateDate = useFormatDateTime();

    const finalFormatDate = (date: AnyDate | undefined) => {
        if (typeof date === "undefined") return "";
        if (typeof date === "string") date = new Date(Number(date));
        return formateDate(date, FORMAT_INTL_OPTIONS_MAP["default"]);
    };

    return finalFormatDate;
}
